import React from "react";

const STYLES = {
  feature: "bg-emerald-50 text-emerald-700 border-emerald-200",
  improvement: "bg-blue-50 text-blue-700 border-blue-200",
  fix: "bg-slate-100 text-slate-600 border-slate-200",
};
export const TAG_LABELS = { feature: "New feature", improvement: "Improvement", fix: "Fix" };

export default function UpdateTag({ tag }) {
  return (
    <span className={`inline-flex items-center text-[10px] font-semibold uppercase tracking-wide border rounded-full px-2 py-0.5 ${STYLES[tag] || STYLES.fix}`}>
      {TAG_LABELS[tag] || tag}
    </span>
  );
}
